<template>
  <b-overlay
    :show="loader.contenido"
    opacity="0.50"
    rounded="sm"
  >
    <b-card>
      <titleSection
        title="Contenido"
        subtitle="Información relacionada a las materias de una especialidad"
        icon="ClipboardIcon"
      />
    </b-card>

    <section
      v-if="contenido.length"
      id="temporalidad-tabs"
    >
      <b-tabs
        vertical
        content-class="col-12 col-md-8 col-lg-9"
        pills
        nav-wrapper-class="faq-navigation col-md-4 col-lg-3 col-12"
        nav-class="nav-left"
      >

        <!-- TEMPORALIDAD Y MATERIAS -->
        <b-tab
          v-for="content in contenido"
          :key="content.orden"
        >
          <!-- TEMPORALIDAD -->
          <template #title>
            <span class="font-weight-bold">{{ content.temporalidad +' '+ content.orden }}</span>
          </template>

          <b-card
            v-for="materia in content.materias"
            :key="materia.id +'-'+ materia.clave"
          >
            <!-- NOMBRE DE MATERIA, CLAVE, BOTÓN DE MÓDULOS E IMAGEN DE MATERIA -->
            <b-row class="pb-50">
              <!-- NOMBRE DE MATERIA, OBJETIVO Y BOTÓN DE MÓDULOS -->
              <b-col
                lg="6"
                order-lg="1"
                order="2"
                class="d-flex justify-content-between flex-column"
              >
                <!-- NOMBRE DE MATERIA Y OBJETIVO -->
                <div class="mt-1 mt-lg-0">
                  <h4 class="font-weight-bolder">
                    {{ materia.nombre }}
                  </h4>
                  <!-- eslint-disable vue/no-v-html -->
                  <small v-html="materia.objetivo" />
                  <!-- eslint-enable -->
                </div>

                <!-- BOTÓN PARA VER MÓDULOS -->
                <b-button
                  v-if="materia.modulos.length"
                  v-b-toggle.sidebar-modulos-materias
                  v-ripple.400="'rgba(255, 255, 255, 0.15)'"
                  variant="primary"
                  class="shadow"
                  @click="materiaSelected = materia"
                >
                  Contenido temático
                </b-button>
              </b-col>

              <!-- CLAVE DE MATERIA E IMAGEN DE MATERIA -->
              <b-col
                lg="6"
                cols="12"
                order-lg="2"
                order="1"
                class="d-flex justify-content-between flex-column text-right"
              >
                <!-- CLAVE DE MATERIA -->
                <div>
                  <b-badge
                    variant="success"
                    class="badge-glow mb-1"
                  >
                    Clave - {{ materia.clave }}
                  </b-badge>
                </div>
                <!-- IMAGEN -->
                <img
                  src="@/assets/images/illustration/api.svg"
                  alt="Imagen de materia"
                >
              </b-col>
            </b-row>
          </b-card>
        </b-tab>

      </b-tabs>

      <sidebar-materias
        id-sidebar="sidebar-modulos-materias"
        :materia="materiaSelected"
      />

    </section>

    <section v-else>
      <b-alert
        class="text-center"
        variant="danger"
        show
      >
        <h4 class="alert-heading">
          {{ error.status }} - Error cargando contenido
        </h4>
        <div class="alert-body">
          <span>{{ error.message }}</span>
        </div>
      </b-alert>
    </section>
  </b-overlay>
</template>

<script>
import {
  BCard, BOverlay, BTabs, BTab, BRow, BCol, BBadge, BAlert, VBToggle, BButton,
} from 'bootstrap-vue'
import { getData } from '@core/utils/http/general'
import titleSection from '@/views/components/title-section.vue'
import Ripple from 'vue-ripple-directive'
import SidebarMaterias from '../../sidebar-materias/sidebar-modulos.vue'

export default {
  components: {
    titleSection,
    BCard,
    BOverlay,
    BTabs,
    BTab,
    BRow,
    BCol,
    BBadge,
    BAlert,
    BButton,

    SidebarMaterias,
  },
  directives: {
    'b-toggle': VBToggle,
    Ripple,
  },
  data() {
    return {
      loader: { contenido: false },
      contenido: [],
      error: {
        status: '',
        message: '',
      },
      materiaSelected: {},
    }
  },
  created() {
    this.get_planEstudios()
  },
  methods: {
    get_planEstudios() {
      this.loader.contenido = true
      getData({ action: 16, plan_estudios: this.$route.params.id })
        .then(response => {
          if (response.status !== 200 || response.data.status !== 200) {
            this.error.status = response.data.status
            this.error.message = response.data.message
            this.$bvToast.toast(response.data.message, {
              title: `${response.data.status} - Error cargando contenido`,
              variant: 'danger',
              solid: true,
            })
          } else this.contenido = response.data.data

          this.loader.contenido = false
        })
        .catch(err => {
          this.loader.contenido = false
          this.$bvToast.toast(err, {
            title: 'Error en solicitud [contenido]',
            variant: 'danger',
            solid: true,
          })
        })
    },
  },
}
</script>
